import { render, staticRenderFns } from "./BookingList.vue?vue&type=template&id=9152da22&scoped=true&"
import script from "./BookingList.vue?vue&type=script&lang=ts&"
export * from "./BookingList.vue?vue&type=script&lang=ts&"
import style0 from "./BookingList.vue?vue&type=style&index=0&id=9152da22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9152da22",
  null
  
)

export default component.exports